import { ReactNode, useState } from "react";
import { Table } from "react-bootstrap";
import { CajaCurricularI } from "interfaces/CajaCurricular";
import { CajasCurricularesRow } from "./CajasCurricularesRow";

interface Props {
  elementos: CajaCurricularI[];
  renderActions?: (elemento: CajaCurricularI) => ReactNode;
}

export const CajasCurricularesTable = ({
  elementos = [],
  renderActions,
}: Props) => {
  const [selectedNotificacionId, setSelectedNotificacionId] = useState<
    null | number | string
  >(null);

  const [showDetailModal, setShowDetailModal] = useState(false);

  const handleShowDetailModal = (id: number | string) => {
    setSelectedNotificacionId(id);
    setShowDetailModal(true);
  };

  const handleCloseModal = () => {
    setShowDetailModal(false);
  };

  return (
    <>
      <Table striped bordered className="table-container">
        <thead>
          <tr className="table-heading">
            <th>ID</th>
            <th>Nombre</th>
            <th>Espacio Curricular</th>
            <th>Plan de estudio</th>
            <th>Horas semanales (1C / 2C)</th>
            <th>Cantidad Espacio Curriculares</th>
            {renderActions && <th className="text-center">Acciones</th>}
          </tr>
        </thead>
        <tbody>
          {elementos.length > 0 ? (
            elementos.map((ctEl) => (
              <CajasCurricularesRow
                key={ctEl.id}
                elemento={ctEl}
                renderActions={renderActions}
              />
            ))
          ) : (
            <tr>
              <td
                colSpan={renderActions ? 6 : 5}
                className="text-center table-error-message"
              >
                <p>
                  <b>No hay Cajas Curriculares para visualizar.</b> Para poder
                  visualizar las cajas curriculares debes <br /> seleccionar el
                  botón agregar «Nueva Caja Curricular».
                </p>
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </>
  );
};
